export default "__VITE_ASSET__DOaaqazB__"